import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { NestedRadioForm } from '../NestedRadioForm';
import { getResolutionOptions } from './helpers';
import { store } from '../../store';
import { selectRefundOption } from '../../actions/refunds';
import { setSelectedOption } from '../../actions/options';
import { receiveResolutionType, resolutionFormCompleted } from '../../actions/resolutions';
import {REFUND_OPTION_TYPES} from "../../constants/refundOptions";

const mapStateToProps = ({ page: { productType }, returnsSettings }) => ({
  refundOptionSettings: returnsSettings[productType]?.refund_option,
  refundApiEnabled: returnsSettings[productType]?.refunds?.enable_api,
});

const ResolutionFormComponent = ({
  refundOptionSettings,
  refundApiEnabled,
  onChange,
  resolutionsConfig,
}) => {
  let options = [];
  let refundType = REFUND_OPTION_TYPES.NONE;

  const handleFormChange = (e) => {
    const selectedResolution = e?.selectedOptions?.find((item) => item?.id?.startsWith('resolution'));
    if (selectedResolution) {
      store.dispatch(receiveResolutionType(selectedResolution.value));
    }

    if (refundType === REFUND_OPTION_TYPES.STATIC) {
      const selectedOption = e?.selectedOptions.find((item) => item?.id?.startsWith('refund_option'));
      if (selectedOption) {
        store.dispatch(selectRefundOption(selectedOption.value));
        store.dispatch(setSelectedOption(selectedOption));
        onChange(selectedOption);
      } else {
        store.dispatch(selectRefundOption(undefined));
        store.dispatch(setSelectedOption(undefined));
      }
    }
    if (refundType === REFUND_OPTION_TYPES.ESTIMATE) {
      const selectedOption = e?.selectedOptions.find((item) => item?.id?.startsWith('refunds'));
      if (selectedOption) {
        store.dispatch(selectRefundOption(selectedOption.type));
        store.dispatch(setSelectedOption(selectedOption));
      } else {
        store.dispatch(selectRefundOption(undefined));
        store.dispatch(setSelectedOption(undefined));
      }
    }
    store.dispatch(resolutionFormCompleted(e.reachedEnd));
  };

  if (refundOptionSettings?.enabled && refundOptionSettings?.options?.length > 0) {
    refundType = REFUND_OPTION_TYPES.STATIC;
  } else if (refundApiEnabled) {
    refundType = REFUND_OPTION_TYPES.ESTIMATE;
  } else {
    refundType = REFUND_OPTION_TYPES.NONE;
  }

  options = getResolutionOptions({
    optionSource: { refundOptionSettings },
    resolutionsConfig,
    type: refundType,
  });

  if(options.length === 0) {
    store.dispatch(resolutionFormCompleted(true));
  }

  return (
    <NestedRadioForm
      onChange={handleFormChange}
      options={options}
      header={{ langKey: 'returns.step_3.resolution.resolution_label' }}
    />
  );
};

export const ResolutionForm = connect(mapStateToProps)(ResolutionFormComponent);

const descriptionPropType = PropTypes.shape({
  content: PropTypes.string.isRequired,
  langKey: PropTypes.string,
});

const titlePropType = PropTypes.shape({
  content: PropTypes.string.isRequired,
  langKey: PropTypes.string,
});

const conditionsPropType = PropTypes.shape({
  includes: PropTypes.arrayOf(PropTypes.string).isRequired,
  type: PropTypes.string.isRequired,
});

const childrenPropType = PropTypes.shape({
  nodes: PropTypes.arrayOf(PropTypes.string).isRequired,
  header: PropTypes.shape({
    langKey: PropTypes.string.isRequired,
  }),
});

const itemPropType = PropTypes.shape({
  root: PropTypes.bool,
  default: PropTypes.bool,
  post_data: PropTypes.bool,
  text: PropTypes.string,
  value: PropTypes.string.isRequired,
  key: PropTypes.string,
  id: PropTypes.string.isRequired,
  title: titlePropType.isRequired,
  description: descriptionPropType.isRequired,
  children: childrenPropType,
  conditions: PropTypes.arrayOf(conditionsPropType),
});

ResolutionFormComponent.defaultProps = {
  refundOptionSettings: null,
  refundApiEnabled: false,
};

ResolutionFormComponent.propTypes = {
  refundOptionSettings: PropTypes.shape({
    enabled: PropTypes.bool,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.string,
      }),
    ),
  }),
  refundApiEnabled: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  resolutionsConfig: PropTypes.arrayOf(itemPropType).isRequired,
};
